/*
Description: Pure Raintree label helpers shared by RaintreeInject, NewRaintreeInject
and RaintreeCapture. Moved verbatim from the two injectors, which had identical copies.
*/

/** Strip trailing Raintree section markers like "(S)", "(O)" from panel captions and expand PT abbreviations. */
export function panelCaptionName(panel: Element): string {
  const text =
    panel.querySelector('.w-panel-caption-text')?.textContent?.trim() || '';
  const stripped = text.replace(/\s*\([A-Z]\)\s*$/, '').trim();
  const ptAbbrLower: Record<string, string> = {
    'flex': 'Flexion', 'ext': 'Extension', 'abd': 'Abduction',
    'add': 'Adduction', 'er': 'External Rotation', 'ir': 'Internal Rotation',
    'ha': 'Horizontal Adduction', 'habd': 'Horizontal Abduction',
  };
  return ptAbbrLower[stripped.toLowerCase()] ?? stripped;
}

/** Map Raintree tab data-name values to human-readable section names.
 *  Strips trailing digits so subjective1/subjective2/etc. all map to 'Subjective'. */
export function tabDataNameToSectionName(tabName: string): string {
  const base = tabName.replace(/\d+$/, '');
  const map: Record<string, string> = {
    subjective: 'Subjective',
    objective: 'Objective',
    assess: 'Assessment',
    plan: 'Plan',
    activities: 'Activities',
    goals: 'Goals'
  };
  return map[base] || map[tabName] || tabName;
}

/** Normalize a key for fuzzy matching: lowercase, strip non-alphanumeric except spaces */
export function normalizeKey(key: string): string {
  return key
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
